import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model"

export class UpdateMovimientoExpedienteRequest extends UpdateKeyValueRequest {

  public idExpediente!: number
  public idEstadoMovimientoExpediente!: number
  public idEscrito!: number
  public idArchivo!: number
  public fecha!: string

}
